import {
  NSP_TOUR,
  DASHBOARD_TOUR,
  CLIENT_TOUR,
  BASE_WEEK_TOUR,
  SINGLE_DAY_TOUR,
  SHOW_TOOLTIP,
  NOTIFICATIONS_TOUR,
} from "../Actions/types";

const INITIAL_STATE = {
  nspContextTour: false,
  dashboardTour: false,
  clientTour: false,
  baseWeekTour: false,
  singleDayTour: false,
  showTooltip: false,
  notificationsTour: false,
};

let onboardingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NSP_TOUR:
      return { ...state, nspContextTour: action.payload };
    case DASHBOARD_TOUR:
      return { ...state, dashboardTour: action.payload };
    case CLIENT_TOUR:
      return { ...state, clientTour: action.payload };
    case BASE_WEEK_TOUR:
      return { ...state, baseWeekTour: action.payload };
    case SINGLE_DAY_TOUR:
      return { ...state, singleDayTour: action.payload };
    case SHOW_TOOLTIP:
      return { ...state, showTooltip: action.payload };
    case NOTIFICATIONS_TOUR:
      return { ...state, notificationsTour: action.payload };
    default:
      return state;
  }
};

export default onboardingReducer;
